export const filterWrapperStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  justifyContent: 'flex-end',
};

export const authorChipStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 10px 4px 4px',
  borderRadius: '20px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  cursor: 'pointer',
  transition: 'all 0.15s ease',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
};

export const activeAuthorChipStyles = {
  ...authorChipStyles,
  borderColor: ({ palette }) => palette.primary.main,
  backgroundColor: ({ palette }) => palette.primary.extraSoft,

  '&:hover': {
    backgroundColor: ({ palette }) => palette.primary.soft,
  },
};

const chipAvatarStyles = {
  width: '22px',
  height: '22px',
  fontSize: '1rem',
  fontWeight: 500,
};

export const getChipAvatarBorderStyles = borderColor => ({
  ...chipAvatarStyles,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: ({ palette }) => borderColor || palette.border.input,
});

export const chipNameStyles = {
  color: 'text.secondary',
  whiteSpace: 'nowrap',
};
